import React from "react";
import ReactDOM from "react-dom";
import {Provider} from './components/utils.jsx';
import poly from "poly-js-utils";
import css from "./common/dynamic-css-loader.js";
import NewsPage from "./components/news_page";

poly.KalturaHelpers.init();
css.loadDynamicCss();

ReactDOM.render(
    <Provider JSContext={window.JSContext}>
        <NewsPage />
    </Provider>,
    document.getElementById('app')
);



// WEBPACK FOOTER //
// ./news.js